<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Slider Çevirisi Ekle">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span><strong>Not:</strong> Eklenecek eğitmen bağlantı linki
                benzersiz olmalıdır...</span>
            </div>
          </b-alert>
          <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" to="/sliders">
            Slider Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Slider Çeviri Ekleme Formu">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Başlık" label-for="title">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Başlık">
                    <b-form-input id="title" v-model="title" placeholder="Başlık"
                      :state="errors.length > 0 ? false : null"
                      :class="title.length >= chars.title ? 'text-danger' : ''" />
                    <small class="textarea-counter-value float-right"
                      :class="title.length >= chars.title ? 'bg-danger' : ''">
                      <span class="char-count">{{ title.length }}</span>
                      /
                      {{ chars.title }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Metin" label-for="text">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Slider Metni">
                    <b-form-textarea id="text" v-model="text" placeholder="Slider Metni" rows="3" class="char-textarea"
                      :state="errors.length > 0 ? false : null" :class="
                        text.length >= chars.text
                          ? 'text-danger'
                          : ''
                      " />
                    <small class="textarea-counter-value float-right" :class="
                      text.length >= chars.text
                        ? 'bg-danger'
                        : ''
                    ">
                      <span class="char-count">{{
                          text.length
                      }}</span>
                      /
                      {{ chars.text }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Slider Tipi" label-for="sliderType">
                  <validation-provider #default="{ errors }" :rules="{
                    required: true
                  }" name="Slider Tipi">
                    <v-select id="sliderType" v-model="selectedSliderType" label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="sliderTypes" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Bağlantı Tipi" label-for="linkType">
                  <validation-provider #default="{ errors }" :rules="{
                    required: true
                  }" name="Bağlantı Tipi">
                    <v-select id="linkType" v-model="selectedSliderLinkType" label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="sliderLinkTypes" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="selectedSliderLinkType.type == 'content' || selectedSliderLinkType.type == 'category'">
              <b-col>
                <b-form-group label="Kategori" label-for="category">
                  <validation-provider #default="{ errors }" :rules="{
                    required: selectedSliderLinkType.type == 'content' ? true : false
                  }" name="Kategori">
                    <v-select id="category" v-model="selectedCategory" label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="categories" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="selectedSliderLinkType.type == 'content'">
              <b-col>
                <b-form-group label="İçerik" label-for="content">
                  <validation-provider #default="{ errors }" :rules="{
                    required: selectedSliderLinkType.type == 'content' ? true : false
                  }" name="İçerik">
                    <v-select id="content" v-model="selectedContent" label="title"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="contents" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="selectedSliderLinkType.type == 'event'">
              <b-col>
                <b-form-group label="Etkinlik" label-for="event">
                  <validation-provider #default="{ errors }" :rules="{
                    required: selectedSliderLinkType.type == 'event' ? true : false
                  }" name="Etkinlik">
                    <v-select id="event" v-model="selectedEvent" label="title"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="events" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="selectedSliderLinkType.type == 'external'">
              <b-col cols="12">
                <b-form-group label="Slider Linki" label-for="url">
                  <validation-provider #default="{ errors }"
                    :rules="{ required: selectedSliderLinkType.type == 'external' ? true : false }" name="Slider Linki">
                    <b-form-input id="url" v-model="url" placeholder="Slider Linki"
                      :state="errors.length > 0 ? false : null" :class="url.length >= chars.url ? 'text-danger' : ''" />
                    <small class="textarea-counter-value float-right"
                      :class="url.length >= chars.url ? 'bg-danger' : ''">
                      <span class="char-count">{{ url.length }}</span>
                      /
                      {{ chars.url }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group label="Görsel Başlığı (title)" label-for="imageTitle">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Görsel Başlığı (title)">
                    <b-form-textarea id="imageTitle" v-model="imageTitle" placeholder="Görsel Başlığı (title)" rows="3"
                      class="char-textarea" :state="errors.length > 0 ? false : null" :class="
                        imageTitle.length >= chars.imageTitle
                          ? 'text-danger'
                          : ''
                      " />
                    <small class="textarea-counter-value float-right" :class="
                      imageTitle.length >= chars.imageTitle ? 'bg-danger' : ''
                    ">
                      <span class="char-count">{{ imageTitle.length }}</span>
                      /
                      {{ chars.imageTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Görsel Açıklaması (alt text)" label-for="imageAltText">
                  <validation-provider #default="{ errors }" :rules="{ required: true }"
                    name="Görsel Açıklaması (alt text)">
                    <b-form-textarea id="imageAltText" v-model="imageAltText" placeholder="Görsel Açıklaması (alt text)"
                      rows="3" class="char-textarea" :state="errors.length > 0 ? false : null" :class="
                        imageAltText.length >= chars.imageAltText
                          ? 'text-danger'
                          : ''
                      " />
                    <small class="textarea-counter-value float-right" :class="
                      imageAltText.length >= chars.imageAltText
                        ? 'bg-danger'
                        : ''
                    ">
                      <span class="char-count">{{ imageAltText.length }}</span>
                      /
                      {{ chars.imageAltText }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <DragDropImage ref="refCardImageMobile" title="Mobil Slider Görseli" :imageUrl="null" :required="true">
                </DragDropImage>
              </b-col>
              <b-col md="8">
                <DragDropImage ref="refCardImage"
                  title="Masaüstü Slider Görseli (Dış bağlantı ve Sadece Görsel için zorunlu)" :imageUrl="null"
                  :required="selectedSliderLinkType.type == 'external' ? true : false">
                </DragDropImage>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="mt-5">
                <b-button class="float-left mt-2" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
                  @click="postConfirmText(true, true)">Önizleme </b-button>
              </b-col>
              <b-col md="6" class="mt-5">
                <b-button class="float-right mt-2" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-success"
                  @click="postConfirmText(false, false)">
                  <b-spinner v-if="spinner === true && isDraft === false" small />
                  {{
                      spinner === true && isDraft === false
                        ? "Yayınlanıyor"
                        : "Yayınla"
                  }}
                </b-button>
                <b-button class="float-right mt-2 mr-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-warning" @click="postConfirmText(true, false)">
                  <b-spinner v-if="spinner == true && isDraft == true" small />
                  {{
    spinner == true && isDraft == true
      ? "Taslağa Kaydediliyor"
      : "Taslağa Kaydet"
                  }}
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../../components/DragDropImage";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  max,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    max,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      url: "",
      text: "",
      title: "",
      image: null,
      slider: "",
      isDraft: false,
      imageTitle: "",
      imageAltText: "",
      events: [],
      contents: [],
      categories: [],
      sliderTypes: [
        { name: 'Beyaz', type: 'white' },
        { name: 'Siyah', type: 'black' },
        { name: 'Transparan', type: 'transparent' },
        { name: 'Sadece Görsel', type: 'only-image' }
      ],
      sliderLinkTypes: [],
      selectedEvent: {},
      selectedContent: {},
      selectedCategory: {},
      selectedSliderType: {},
      selectedSliderLinkType: {},
      chars: {
        title: 30,
        text: 50,
        url: 255,
        imageTitle: 60,
        imageAltText: 140
      },
      snowOption: {
        theme: "snow",
      },
      spinner: false,
      idParam: this.$route.params.idParam,
      targetLocale: this.$route.query.targetLocale,
    };
  },
  watch: {
    selectedCategory(newSelectedCategory, oldSelectedCategory) {
      this.getContentsByCategorySlug(newSelectedCategory.slug)
    }
  },
  methods: {
    postConfirmText(isDraft, preview) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Yeni slideri kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit(preview);
        }
      });
    },
    getEvents() {
      endpoints
        .getEvents(null, this.targetLocale, () => { })
        .then((data) => {
          this.events = [];
          this.events = [...data.response];
          this.selectedEvent = this.events[0]
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategories() {
      endpoints
        .getCategories(null, this.targetLocale, () => { })
        .then((data) => {
          this.categories = []
          this.categories = [...data.response]
          this.selectedCategory = this.categories[0]

        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSliderLinkTypes() {
      endpoints
        .getSliderLinkTypes(null, this.targetLocale, () => { })
        .then((data) => {
          this.sliderLinkTypes = [...data.response];
          this.selectedSliderLinkType = this.sliderLinkTypes[0]
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoriesBySlugFlat() {
      endpoints.getCategoriesBySlugFlat(this.targetLocale == 'tr' ? 'programlar' : 'programs', this.targetLocale, () => { }).then((data) => {
        this.categories = [];
        this.categories = [...data.response];
        this.selectedCategory = this.categories[0]
      }).catch((err) => {
        console.log(err);
      });
    },
    getContentsByCategorySlug(slug) {
      endpoints.
        getContentsByCategorySlug(slug, this.targetLocale, () => { })
        .then((data) => {
          this.contents = [];
          this.contents = [...data.response];
          this.selectedContent = this.contents[0]
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postSubmit(preview) {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();
          formData.append("id", this.slider.id)
          formData.append("text", this.text)
          formData.append("type", this.selectedSliderType.type)
          formData.append("title", this.title)
          formData.append("isDraft", this.isDraft)
          formData.append("imageTitle", this.imageTitle)
          formData.append("imageAltText", this.imageAltText)
          formData.append("imageMobile", this.$refs.refCardImageMobile.image)
          formData.append("sliderLinkTypeId", this.selectedSliderLinkType.id)
          switch (this.selectedSliderLinkType.type) {
            case 'category':
              formData.append("categoryId", this.selectedCategory.id)
              if (this.$refs.refCardImage.image != null) {
                formData.append("image", this.$refs.refCardImage.image)
              }
              break;
            case 'content':
              formData.append("contentId", this.selectedContent.id)
              if (this.$refs.refCardImage.image != null) {
                formData.append("image", this.$refs.refCardImage.image)
              }
              break;
            case 'event':
              formData.append("eventId", this.selectedEvent.id)
              if (this.$refs.refCardImage.image != null) {
                formData.append("image", this.$refs.refCardImage.image)
              }
              break;
            case 'external':
              formData.append("url", this.url)
              formData.append("image", this.$refs.refCardImage.image)
              break;
            default:
              break;
          }
          endpoints
            .postSliders(formData, this.targetLocale, () => { })
            .then((data) => {
              this.spinner = false;

              if (preview == true) {
                window.open(`${settings.uiBaseUrl}`, '_blank');
              }
              this.$swal({
                icon: "success",
                title: "Kayıt başarılı!",
                text: "Yeni slider eklendi.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              }).then((result) => {
                if (result.value) {
                  this.$router.push({
                    path: `/sliders`,
                  });
                }
              });
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },

  },
  created() { },
  destroyed() { },
  mounted() {
    this.getEvents()
    this.getCategories()
    this.getSliderLinkTypes()
    setTimeout(() => {
      endpoints
        .getSlidersById(this.idParam, this.targetLocale, () => { })
        .then((data) => {
          this.slider = data.response;
          this.selectedSliderType = this.sliderTypes.find(e => e.type == this.slider.type)
          this.selectedSliderLinkType = this.sliderLinkTypes.find(e => e.type == this.slider.sliderLinkType.type)
        })
        .catch((err) => {
          console.log(err);
        });
    }, 500);
    localize('tr')
  },
  setup() {
  }
};
</script>
<style lang="css">
.ql-container {
  margin-top: 30px;
}

.ql-container,
.ql-editor {
  min-height: 300px !important;
  margin-bottom: 30px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
